/**
 * In base alla configurazione data viene definitio grazie a questa funzione
 * quale pannello fare vedere.
 * @param {obj} currentIndex
 * @param {obj} indexPanel 
 * @returns 
 */
export const chooseTransformClass = ({ currentIndex, indexPanel }) => {
  const calcTransform = indexPanel - currentIndex;
  if (calcTransform > 0) {
    return `${calcTransform}pos`;
  }
  return '';
};
